// Standard library imports
import React, { useEffect, useState } from 'react';

// External library imports
import { Form, Formik } from 'formik';
import { UilInfoCircle } from '@iconscout/react-unicons';
import { toast } from 'react-toastify';
import moment from 'moment';
import _, { capitalize } from 'lodash';
// Internal module imports
import Table from '../../../../components/Table/Table';
import Typography from '../../../../components/Typography/Typography';
import NewJSONEditor from '../../../../components/JSONEditor/NewJSONEditor';
import DatePicker from '../../../../components/Inputs/DatePicker/DatePicker';
import { useLoader } from '../../../../hooks/use-loader.hook';
import ModalComponent from '../../../../components/ModalComponent/ModalComponent';
import { RootAfrrService } from '../../../../services/RootAfrrService';
import CustomTooltip from '../../../../components/CustomToolTip/CustomTooltip';

// Css imports
import classes from '../../../../styles/AllDevices.module.css';
import { momentTimeFormater } from '../../../../utils/dateHelper';

const LIMIT = 15;

const EdxCommunicationlogs = ({ queryParamsData }) => {
    const [startLoader, stopLoader] = useLoader();
    const [data, setData] = useState([]);
    const [skip, setSkip] = useState(0);
    const [page, setPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [date, setDate] = useState(queryParamsData.date ? queryParamsData.date : new Date());
    const [infoModal, setInfoModal] = useState({ status: false, data: '' });

    useEffect(() => {
        getLogs();
    }, [date, skip]);

    const getLogs = () => {
        const params = {
            limit: LIMIT,
            skip,
            date: moment(date).format('YYYY-MM-DD'),
        };
        RootAfrrService.GetEdxCommunicationLogs(params, startLoader, handleSuccess, handleError, stopLoader);
    };

    const handleSuccess = ({ data }) => {
        const processedData = _.get(data, ['data', 'data'], []).map((item) => ({
            messageType: _.get(item, ['messageData', 'businessType'], '--'),
            type: capitalize(item.type),
            sender: _.get(item, ['messageData', 'senderCode'], '--'),
            service: _.get(item, 'service', '--'),
            createdAt: momentTimeFormater(item.createdAt).format('YYYY-MM-DD HH:mm:ss'),
            action: (
                <div
                    style={{
                        display: 'flex',
                        gridColumnGap: '1vw',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <CustomTooltip content={'XML'}>
                        <UilInfoCircle size={'1.2vw'} style={{ color: 'var(--color-primary)' }} onClick={() => setInfoModal({ status: true, data: item.xml || '' })} />
                    </CustomTooltip>
                </div>
            ),
        }));
        setTotalCount(_.get(data, ['data', 'totalCount'], 0));
        setData(processedData);
    };

    const handleError = (err) => {
        let data = err && err.response ? err.response.data : null;
        if (data) toast.error(data.message);
        else toast.error('Internal server error!');
    };

    const handlePageChange = (pageno) => {
        setSkip(LIMIT * pageno);
        setPage(pageno);
    };

    return (
        <div>
            <div className={classes.AllDevices} style={{ marginBottom: '2vh' }}>
                <div className={classes.Header}>
                    <div></div>
                    <div className={classes.InputContainer2}>
                        <div className={classes.FieldControl2}>
                            <div className={classes.BadgeContainer}>
                                <div>
                                    <label>Date</label>
                                    <DatePicker date={date} setDate={setDate} showArrow={true} />
                                </div>
                            </div>
                        </div>

                        <button
                            type="submit"
                            className="btn-primary"
                            style={{
                                marginTop: '3vh',
                                width: 'auto',
                            }}
                            onClick={getLogs}
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </div>
            <div className={classes.AllDevices}>
                <div className={classes.Header}>
                    <div>
                        <Typography content={'EDX Communication Logs'} />
                        <div className={classes.TableCount}>
                            Total Count :
                            <span>
                                <Typography size="14" content={totalCount} />
                            </span>
                        </div>
                    </div>
                </div>

                <div>
                    <Table
                        head={['Message Type', 'Direction', 'Service', 'Sender', 'CreatedAt (CET)', 'Action']}
                        keys={['messageType', 'type', 'service', 'sender', 'createdAt', 'action']}
                        data={data}
                        page={page}
                        Pagination={true}
                        limit={LIMIT}
                        handlePageChange={handlePageChange}
                        totalCount={totalCount}
                    />
                </div>

                <ModalComponent isOpen={infoModal.status} setOpen={(status) => setInfoModal({ status, data: '' })}>
                    <div style={{ width: '50vw' }}>
                        <div>
                            <Typography content={'XML'}></Typography>
                            <div>
                                <div>
                                    <Formik>
                                        {() => {
                                            return (
                                                <Form>
                                                    <NewJSONEditor name="request" defaultValue={infoModal.data} height="80vh" defaultLanguage="xml" />
                                                </Form>
                                            );
                                        }}
                                    </Formik>
                                </div>
                                <div className={classes.ButtonRight}>
                                    <div className="btn-secondary" onClick={() => setInfoModal({ status: false, data: '' })}>
                                        Close
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalComponent>
            </div>
        </div>
    );
};

export default EdxCommunicationlogs;
